import api from "./api";

const UsertoModuleService = {
  getAllUserToModule() {
    return api.get(`/api/v1/userToModule`);
  },

  createUserToModule(data) {
    return api.post(`/api/v1/userToModule`, data);
  },

  updateUserToModuleStatus(UserToModuleId, statusId) {
    return api.put(
      `/api/v1/userToModule/${UserToModuleId}/statusUpdate/${statusId}`,
    );
  },

  updateModule(userToModuleId, data) {
    return api.put(`/api/v1/userToModule/${userToModuleId}`, data);
  },

  deleteModule(userToModuleId) {
    return api.delete(`/api/v1/userToModule/${userToModuleId}`);
  },

  getUserToModuleId(userToModuleId) {
    return api.get(`/api/v1/userToModule/${userToModuleId}`);
  },

  getUserToModuleIdByUserId(UserId) {
    return api.get(`/api/v1/userToModule/user/${UserId}`);
  },
};

export default UsertoModuleService;
